import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Form,
  FormError,
  LabelInput,
} from '../../common/components/form';
import { StyledFormFooter } from '../../common/components/form/ui';
import Button from '../../../ui/button/Button';

import { Localize } from '../../../locale/localization';

const LoginForm = (props) => {
  const {
    enabled,
    onSubmit,
    onBlur,
    onInputChange,
    formError,
    errors,
    touchedFields,
    isValid,
    email,
    password,
  } = props;

  return (
    <Form
      onSubmit={onSubmit}
      autoCorrect="off"
      autoComplete
      noValidate
      spellCheck="false"
      onBlur={onBlur}
    >
      <LabelInput
        label={Localize("form.user.label")}
        name="email"
        type="email"
        value={email}
        error={errors['email'] && touchedFields.indexOf('email') > -1}
        errorMessage={errors['email']}
        onChange={onInputChange}
      />
      <LabelInput
        label={Localize("form.pass.label")}
        name="password"
        type="password"
        value={password}
        error={errors['password'] && touchedFields.indexOf('password') > -1}
        errorMessage={errors['password']}
        onChange={onInputChange}
      />
      {formError && (
        <FormError dangerouslySetInnerHTML={{__html : formError}} />
      )}
    <StyledFormFooter column>
      <Button disabled={!isValid || !enabled} type="submit">{Localize("login")}</Button>
      <NavLink to="/resetPassword">{Localize("form.pass.forgot")}</NavLink>
    </StyledFormFooter>
  </Form>
  );
};

export default LoginForm;


// WEBPACK FOOTER //
// ./src/modules/auth/components/LoginForm.js